/* eslint-disable no-undef */
import 'core-js/stable';

/* eslint-disable */
import LazySizes from 'lazysizes';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
/* eslint-enable */

import { onDocumentReady } from './utils';

// Components
import Menu from '@src/components/menu';
import ShareModal from '@src/components/share-modal';
import Links from '@src/components/links';
import VideoModal from '@src/components/video-modal';
import InPageScroll from '@src/components/in-page-scroll';
import InPageNav from '@src/components/in-page-nav';
import InjectSVG from '@src/components/svg-inject';
import TableOfContents from '@src/components/table-of-contents';
import Accordion from '@src/components/accordion';
import scrollUpNavMobile from '@src/components/scroll-up-nav-mobile';

onDocumentReady(() => {
  new Links();
  new InjectSVG();
  new scrollUpNavMobile();

  if (document.querySelector('.js-page-nav') && document.querySelector('.js-page-nav')) {
    new InPageScroll();
    new InPageNav();
  }

  if (document.querySelector('.dce-block__accordion')) {
    new Accordion();
  }

  const MENU_CLASS = '.js--menu';
  if (document.querySelector(MENU_CLASS)) {
    new Menu(MENU_CLASS);
  }
  const SHARE_MODAL_CLASS = '.js-share-modal';
  if (document.querySelector(SHARE_MODAL_CLASS)) {
    new ShareModal(SHARE_MODAL_CLASS);
  }

  if (document.querySelectorAll('.js-program-card').length) {
    const programs = Array.from(document.querySelectorAll('.js-program-card'));
    programs.forEach(program => new VideoModal(program));
  }

  if (document.querySelector('.js-modal-gallery')) {
    import(/* webpackChunkName: "modal-gallery" */ '@src/components/modal-gallery').then(module => {
      const ModalGallery = module.default;
      new ModalGallery();
    });
  }

  if (document.querySelector('.js-toggle-class')) {
    import(/* webpackChunkName: "modal-gallery" */ '@src/components/toggle-class').then(module => {
      const ToggleClass = module.default;
      new ToggleClass();
    });
  }

  if (document.querySelector('.js-hang-punc')) {
    import(/* webpackChunkName: "hang-punctuation" */ '@src/components/hang-punctuation').then(
      module => {
        const HangPunctuation = module.default;
        new HangPunctuation();
      },
    );
  }

  if (document.querySelector('.article-body__content')) {
    new TableOfContents();
  }

  if (document.querySelector('.wp-block-table')) {
    import(/* webpackChunkName: "hang-punctuation" */ '@src/components/tables').then(module => {
      const Tables = module.default;
      new Tables();
    });
  }

  if (document.querySelector('.js-search')) {
    import(/* webpackChunkName: "search-page" */ '@src/components/search-page').then(module => {
      const SearchPage = module.default;
      new SearchPage();
    });
  }

  if (document.querySelector('.js-set-active')) {
    import(/* webpackChunkName: "set-active" */ '@src/components/set-active').then(module => {
      const SetActive = module.default;
      [...document.getElementsByClassName('js-set-active')].map(el => new SetActive(el));
    });
  }

  if (document.querySelector('.acf-map')) {
    import(/* webpackChunkNAme: "google-maps-embed" */ '@src/components/google-maps-embed').then(
      module => {
        const GoogleMapsEmbed = module.default;
        /* eslint-disable */
        new GoogleMapsEmbed(jQuery('.acf-map'));
      },
    );
  }

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});
